import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LiveRoom from './pages/LiveRoom';

function App() {
  const [entered, setEntered] = useState(!!localStorage.getItem('guest_entered'));
  const [nickname, setNickname] = useState(localStorage.getItem('guest_name') || '');
  const guestUser = { id: 'guest_' + Date.now(), username: nickname || '游客' };
  const guestToken = 'guest_token';

  const handleEnter = (name) => {
    const finalName = name.trim() || '游客';
    localStorage.setItem('guest_entered', '1');
    localStorage.setItem('guest_name', finalName);
    setNickname(finalName);
    setEntered(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('guest_entered');
    setEntered(false);
  };

  if (!entered) {
    return <WelcomePage onEnter={handleEnter} />;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={<LiveRoom token={guestToken} user={guestUser} onLogout={handleLogout} />}
      />
      <Route
        path="/room/:roomId"
        element={<LiveRoom token={guestToken} user={guestUser} onLogout={handleLogout} />}
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

// ── 欢迎页面 ──────────────────────────────────
function WelcomePage({ onEnter }) {
  const [name, setName] = useState(localStorage.getItem('guest_name') || '');

  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-900">
      <div className="bg-dark-800 p-10 rounded-2xl shadow-2xl w-96 text-center">
        <div className="text-6xl mb-6">🎬</div>
        <h1 className="text-3xl font-bold mb-3 text-white">
          视频直播 + AI助手
        </h1>
        <p className="text-gray-400 mb-6 text-sm">
          实时直播 · 智能弹幕 · AI问答
        </p>

        <input
          type="text"
          placeholder="输入你的昵称"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={12}
          className="w-full p-3 mb-4 bg-dark-700 rounded-xl border border-gray-600 focus:border-blue-500 focus:outline-none text-center text-white"
        />

        <button
          onClick={() => onEnter(name)}
          className="w-full py-4 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 rounded-xl text-lg font-bold text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
        >
          🚀 进入平台
        </button>

        <p className="text-gray-500 mt-4 text-xs">
          {name.trim() ? `你好，${name.trim()}！` : '不填昵称将以游客身份进入'}
        </p>
      </div>
    </div>
  );
}

export default App;
